export const APP_NAME = "membership-signup-ui";
export const APP_HEADER_HEIGHT = "80px";

export const APP_HEADER_ADAPTIVE = "66px";
export const APP_HEADER_ICON_HEIGHT_ADAPTIVE = "33px";

export const CARD_WIDTH = "684px";
export const CARD_CONTENT_WIDTH = "339px";

export const RECOMMENDED_PRODUCT_VIEW_EVENT = "recommended_product_view";
export const CART_VIEW_EVENT = "cart_view";
